module.exports = __webpack_public_path__ + "img/bhr.ef135f3c.svg";